<template>
  <div class="holiday-sidebar">
    <b-sidebar
      position="absolute"
      :right="true"
      :fullheight="true"
      :overlay="false"
      :open="sidebarOpen"
      @close="closeSidebar"
    >
      <div class="holiday-sidebar-contents">
        <div class="sidebar-body">
          <label class="input-label">Navn</label>
          <b-input
            class="b-input"
            v-model="chosenHoliday.name"
            :disabled="true"
          >
          </b-input>

          <label class="input-label">Dato</label>
          <b-input
            class="b-input"
            :value="dateFormat(chosenHoliday.date)"
            :disabled="true"
          >
          </b-input>

          <label class="input-label">Alle fri</label>
          <b-checkbox
            class="b-checkbox"
            :value="chosenHoliday.state === 1"
            :true-value="1"
            :false-value="0"
            @input="(value) => (markAllFree(value))"
          ></b-checkbox>
        </div>
        <div class="sidebar-footer">
            <b-button class="is-blue" @click="updateHoliday">Gem</b-button>
            <b-button class="is-white" @click="closeSidebar">Annullér</b-button>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  data: () => ({}),
  mounted() {},
  methods: {
    ...mapActions("holidayStore", ["closeSidebar", "updateHoliday", "setChosenHoliday"]),
    dateFormat(arg) {
      return moment(arg).format("YYYY-MM-DD");
    },
    markAllFree(value){
        let holiday = this.chosenHoliday;
        holiday.state = value;
        this.setChosenHoliday(holiday)
    }
  },
  computed: {
    ...mapGetters("holidayStore", ["sidebarOpen", "chosenHoliday"]),
  },
};
</script>

<style lang="scss">
.holiday-sidebar {
  .holiday-sidebar-contents {
    flex: 1 0 auto;
    border: 3px solid $border;

    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: stretch;

    .sidebar-header {
      flex: 0 1 auto;
      padding: 20px;
    }
    .sidebar-body {
      flex: 1 0 auto;
      padding: 30px 30px;
      .is-expanded,
      .textarea {
        height: 100%;
      }
    }
    .sidebar-footer {
      flex: 0 1 auto;

      .sidebar-footer-controls {
        padding: 20px;
      }
      .sidebar-footer-updated {
        background-color: $border;
      }
    }
    .input-label {
      font-size: 22px;
    }
    .b-input {
      margin-top: 5px;
      margin-bottom: 15px;
    }
    .b-checkbox {
      margin-top: 5px;
      margin-left: 10px;
      margin-bottom: 15px;
    }
  }
}
</style>
